import { ChangeEvent, Dispatch, SetStateAction } from 'react';

import { throwImageFiltering } from '@app/helpers/uploadFileValidation';
import { MESSAGES } from '@app/constant';
import { VisibleEnum } from 'types';
import { IIMage } from '@modules/images';

// eslint-disable-next-line max-len
import { getProductDataProps, handleDeleteBase64ImageProps, handleDeleteImageFromFirebaseProps, onChangeImageUploadInputProps } from './types';

export const getProductData = async ({
  reset,
  productId,
  setState,
  getProductById
}: getProductDataProps) => {
  setState((prev) => ({ ...prev, isLoading: true }))

  try {
    const product = await getProductById(productId).unwrap()

    if (!product) {
      alert('Something went wrong.')

      return
    }

    const found = product.images?.find((file) => file.isMain)

    reset({
      ...product,
      visible: product.visible ? VisibleEnum.YES : VisibleEnum.NO,
      newUploadingImages: {} as DataTransfer['files']
    })
    setState((prev) => ({ ...prev, isLoading: false }))
  } catch (error) {
    console.log(error);
    setState((prev) => ({ ...prev, isLoading: false }))
  }
}

export const onChangeImageUploadInput = ({
  event,
  setState,
  setError,
  newUploadingImages,
  setValue,
  receivedImagesFromBackend
}: onChangeImageUploadInputProps) => {
  try {
    setState((prev) => ({ ...prev, largeImageMessage: '' }))

    const fileList = event.target?.files as FileList
    const onChangeFiles = throwImageFiltering(fileList)
    const chosenImagesLength = Object.keys(onChangeFiles || {}).length

    const alreadyThereAreLength = (receivedImagesFromBackend.length + (newUploadingImages?.length || 0))

    let message = '';

    if (alreadyThereAreLength >= 5) {
      message = 'You can not upload anymore images.';
      setError('images', { message })

      return null
    }

    if ((chosenImagesLength + alreadyThereAreLength) > 5) {
      const hasLength = receivedImagesFromBackend.length + (newUploadingImages?.length || 0)

      message = `You can upload ${5 - hasLength} ${(5 - hasLength) > 1 ? 'images' : 'image'} `

      setError('images', { message })

      return null
    }

    if (fileList.length !== onChangeFiles.length) {
      setState((prev) => ({ ...prev, largeImageMessage: MESSAGES.imageSize }))
    }

    if (onChangeFiles) {
      const mergedFileList = new DataTransfer();

      Array.from(newUploadingImages || []).forEach((file) => mergedFileList.items.add(file));
      Array.from(onChangeFiles).forEach((file) => mergedFileList.items.add(file));

      setValue('newUploadingImages', mergedFileList.files, { shouldValidate: true })
    }
  } catch (error) {
    console.log('Error:', error);
  }
}

export const handleDeleteImageFromFirebase = async ({
  state,
  productId,
  reset,
  setState,
  deleteImage,
  getProductById,
}: handleDeleteImageFromFirebaseProps) => {
  try {
    const { firebaseImageForProcess } = state

    if (!firebaseImageForProcess?.id) {
      return
    }

    setState((prev) => ({ ...prev, isLoading: true, isSuccess: '' }))
    await deleteImage({ id: firebaseImageForProcess.id }).unwrap()
    await getProductData({ reset, productId, setState, getProductById })
    setState((prev) => ({ ...prev, isDeleteModalOpen: false, firebaseImageForProcess: {} as IIMage }))
  } catch (error) {
    console.log('Error:', error);
    setState((prev) => ({
      ...prev,
      isLoading: false,
      isSuccess: 'Could not delete image. Please try again.'
    }))
  }
}

export const handleDeleteBase64Image = ({
  base64,
  previews,
  setValue,
  setState,
  newUploadingImages,
}: handleDeleteBase64ImageProps) => {
  if (!newUploadingImages) {
    return null
  }

  const index = previews.findIndex((item) => item === base64);

  const files = Array.from(newUploadingImages).filter((_, i) => i !== index);

  const mergedFileList = new DataTransfer();

  files.forEach((file) => {
    mergedFileList.items.add(file);
  });

  setValue('newUploadingImages', mergedFileList.files)
  setState((prev) => ({ ...prev, isDeleteModalOpen: false }))
}
